import React from 'react';
import HeaderBar from '../header/HeaderBar';

const Layout = ({ children }) => {
  return (
    <>
      <HeaderBar />
      {children}
    </>
  );
};
export default Layout;
